import { useState } from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  Box,
  Button,
  Card,
  CardHeader,
  Grid,
  TextField,
  Divider,
  CardContent,
  FormHelperText,
} from '@material-ui/core';
import RegionSelector from './RegionSelector';

const selectNotificationTo = [
  { value: 'allWashers', label: 'All Washers' },
  { value: 'allUsers', label: 'All Users' },
  { value: 'region', label: 'Users in Region' },
];

const WhatsAppNotification = (props) => {
  const [region, setRegion] = useState({ concelho: '', freguesia: '' });

  return (
    <Card>
      <CardHeader
        title="Send WhatsApp Message"
        subheader="Requires Meta Business credentials (META_WA_TOKEN, META_WA_PHONE_NUMBER_ID). Until then the request is audited and returns 503."
      />
      <Divider />
      <CardContent>
        <Formik
          initialValues={{
            send_to: selectNotificationTo[0].value,
            message: '',
          }}
          validationSchema={Yup.object().shape({
            send_to: Yup.string().required('Select Notification To is required'),
            message: Yup.string().required('Message is required'),
          })}
          onSubmit={(values) => {
            const payload = { ...values };
            if (values.send_to === 'region') {
              if (!region.concelho) {
                // eslint-disable-next-line no-alert
                window.alert('Pick a municipality first.');
                return;
              }
              payload.region = region;
            }
            props.handleWhatsappNotification(payload);
          }}
        >
          {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label="Select Recipients"
                name="send_to"
                onChange={handleChange}
                required
                select
                SelectProps={{ native: true }}
                value={values.send_to}
                variant="outlined"
              >
                {selectNotificationTo.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </TextField>
              {values.send_to === 'region' && (
                <Box pt={2}>
                  <RegionSelector value={region} onChange={setRegion} label="Target region" />
                  <FormHelperText>
                    Server-side filter: clients whose stored address falls inside the region polygon.
                  </FormHelperText>
                </Box>
              )}
              <TextField
                error={Boolean(touched.message && errors.message)}
                fullWidth
                helperText={touched.message && errors.message}
                label="Enter a message"
                margin="normal"
                name="message"
                multiline
                rows={3}
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.message}
                variant="outlined"
              />
              <Box paddingY={3}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <Button
                      color="primary"
                      disabled={isSubmitting}
                      size="large"
                      fullWidth
                      type="submit"
                      variant="contained"
                    >
                      SEND WHATSAPP MESSAGE
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </form>
          )}
        </Formik>
      </CardContent>
    </Card>
  );
};

WhatsAppNotification.propTypes = {
  handleWhatsappNotification: PropTypes.func,
};

export default WhatsAppNotification;
